// extracted by mini-css-extract-plugin
export default {"scrollUp":"scrollUp_scrollUp__-AUae","scrollUp_icon":"scrollUp_scrollUp_icon__Ts3mo","show-scroll":"scrollUp_show-scroll__Yn0fT"};